export const handleOpenTab = (
	baseUrl: string,
	endpoint: string,
	id: string
) => {
	if (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);

	window.open(`${baseUrl}${endpoint}${id}`, "_blank");
};
